import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-resize-map-control',
    templateUrl: 'resize.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ResizeMapControlComponent {
    @Input() isColllapse = false;
}
